var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarshallIsland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40.0001C31.0454 40.0001 39.9998 31.0457 39.9998 20.0001C39.9998 16.6436 39.1717 13.4809 37.7106 10.7032L19.9763 20.0235L29.2967 2.28931C26.519 0.828213 23.3563 8.7738e-05 19.9998 8.7738e-05C8.95419 8.7738e-05 -0.000183105 8.95446 -0.000183105 20.0001C-0.000183105 25.523 2.23841 30.523 5.85763 34.1423C9.47693 37.7616 14.4769 40.0001 19.9998 40.0001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6897 10.7249C36.7742 8.98244 35.584 7.34642 34.1188 5.88127C32.6536 4.41611 31.0178 3.22588 29.2752 2.31049L5.83447 34.1656L37.6897 10.7249Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83447 34.1656L37.6897 10.7249C36.7742 8.98244 35.584 7.34642 34.1188 5.88127L5.83447 34.1656Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3678 11.7283L14.9253 12.8772L16.226 15.2428L13.5737 14.7354L13.2376 17.4148L11.3901 15.4441L9.54259 17.4148L9.20665 14.7354L6.55431 15.2427L7.85485 12.8771L5.41235 11.7283L7.85493 10.5793L6.55431 8.21386L9.20649 8.72113L9.54267 6.04176L11.3901 8.01246L13.2376 6.04176L13.5737 8.72113L16.2261 8.21386L14.9254 10.5794L17.3678 11.7283Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarshallIsland);
export default __webpack_public_path__ + "static/media/marshall_island.980ad767381a18e24b6f4d02622735c5.svg";
export { ForwardRef as ReactComponent };